import { legacyContractDataAttrs } from '@/msgdeskRuntime/legacyBridge/SelectorContracts'
import { useEditorSurface } from '../../EditorSurfaceContext'

// Email-specific propagation/quoting rules. These retain their exact legacy
// input names and rough slots; only their Configure presentation moved out of
// the general Rules pane.
const emailRows: Array<[string, string]> = [
  ['is_force_email', 'This email is for all children'],
  ['is_quote', 'Quote'],
]

export function EmailPanel() {
  const { skin } = useEditorSurface()
  const classes = skin.settings

  return (
    <fieldset {...legacyContractDataAttrs('editor.settings.email')} className={classes.panel}>
      <legend className={classes.legend}>Email</legend>
      {emailRows.map(([name, label]) => (
        <label key={name} className={classes.check}>
          <input type="checkbox" name={name} value="1" />
          {label}
        </label>
      ))}
    </fieldset>
  )
}
